module.exports = __webpack_public_path__ + "img/marker_four_red1.bbc69a8f.png";